import { useQuery } from '@tanstack/react-query'
import getAttestationAreas from '../../services/ruutsApi/getAttestationAreas'
import { queryKeys } from './queryKeys'

export const useAttestationAreas = (farmId: string | undefined) => {
  const query = useQuery({
    queryKey: queryKeys.attestationAreas(farmId),
    queryFn: ({ signal }) => getAttestationAreas({ farmId: farmId as string, signal }),
    enabled: !!farmId,
  })

  return {
    areas: query.data?.data ?? null,
    warnings: query.data?.meta?.warnings ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  }
}
